<template>
    <form class="card">
        <h3>Доверенные лица</h3>
        <Assistant v-if="status == ''" :data.sync="data"></Assistant>
    </form>
</template>

<script>
    import Assistant from '@/components/forms/Assistant.vue'
    export default {
        props: ['status', 'data'],
        components: {
            Assistant
        },
        created () {
            this.$emit('getData')
        }
    }
</script>